import { userActions } from "../store/user-store/user-slice";

export const isValidEmail = (email) => {
  return /^[A-Za-z0-9._%+-]+@[A-Za-z0-9.-]+\.[A-Za-z]{2,}$/.test(email);
};

export const isValidCed = (cedula) => {
  cedula = cedula.replace("-", "").replace("-", "");
  // La cédula debe tener 11 dígitos
  if (cedula.length !== 11) return false;

  // Validar serie
  if (
    parseInt(cedula.substring(0, 3)) !== 402 &&
    parseInt(cedula.substring(0, 3)) > 121 &&
    parseInt(cedula.substring(0, 3)) < 1
  )
    return false;

  var suma = 0;
  var verificador = 0;

  for (var i = 0; i < cedula.length; i++) {
    let n = cedula.charAt(i);
    //No ejecutar el ultimo digito
    if (i === cedula.length - 1) break;

    // Los dígitos pares valen 2 y los impares 1
    let multiplicador = parseInt(i) % 2 === 0 ? 1 : 2;

    // Se multiplica cada dígito por su paridad
    let digito = parseInt(n) * parseInt(multiplicador);

    // Si la multiplicación da de dos dígitos, se suman entre sí
    digito =
      digito > 9
        ? [...digito.toString()].map((e) => parseInt(e)).reduce((a, b) => a + b)
        : digito;

    // Se va haciendo la acumulación de esa suma
    suma = suma + digito;
  }
  // Al final se obtiene el verificador con la siguiente fórmula
  verificador = (10 - (suma % 10)) % 10;

  // Se comprueba el verificador
  return verificador === parseInt(cedula.slice(-1));
};

export const validateRegisterFields = (index, usuario, dispatch) => {
  let value = true;
  switch (index) {
    case 0:
      if (
        usuario.email === "" ||
        usuario.email === undefined ||
        !isValidEmail(usuario.email)
      ) {
        dispatch(userActions.setFieldValid({ id: "email", value: false }));
        value = false;
      }
      if (usuario.password === "" || usuario.password === undefined) {
        dispatch(
          userActions.setFieldValid({ id: "password", value: false })
        );
        value = false;
      }
      if (usuario.repassword === "" || usuario.repassword === undefined) {
        dispatch(
          userActions.setFieldValid({ id: "repassword", value: false })
        );
        value = false;
      }
      if (usuario.password !== usuario.repassword) {
        dispatch(
          userActions.setFieldValid({ id: "password", value: false })
        );
        dispatch(
          userActions.setFieldValid({ id: "repassword", value: false })
        );
        value = false;
      }
      break;
    case 1:
      if (usuario.nombres === "" || usuario.nombres === undefined) {
        dispatch(userActions.setFieldValid({ id: "nombres", value: false }));
        value = false;
      }
      if (usuario.apellidos === "" || usuario.apellidos === undefined) {
        dispatch(
          userActions.setFieldValid({ id: "apellidos", value: false })
        );
        value = false;
      }
      if (
        usuario.identificacion === "" ||
        usuario.identificacion === undefined
      ) {
        dispatch(
          userActions.setFieldValid({ id: "identificacion", value: false })
        );
        value = false;
      }
      if (
        usuario.telefonoCelular === "" ||
        usuario.telefonoCelular === undefined
      ) {
        dispatch(
          userActions.setFieldValid({ id: "telefonoCelular", value: false })
        );
        value = false;
      }
      break;
    case 2:
      if (usuario.pais === "" || usuario.pais === undefined) {
        dispatch(userActions.setFieldValid({ id: "pais", value: false }));
        value = false;
      }
      if (usuario.ciudad === "" || usuario.ciudad === undefined) {
        dispatch(userActions.setFieldValid({ id: "ciudad", value: false }));
        value = false;
      }
      if (usuario.direccion === "" || usuario.direccion === undefined) {
        dispatch(
          userActions.setFieldValid({ id: "direccion", value: false })
        );
        value = false;
      }
      break;
    case 3:
      if (usuario.entidadLabora === "" || usuario.entidadLabora === undefined) {
        dispatch(
          userActions.setFieldValid({ id: "entidadLabora", value: false })
        );
        value = false;
      }
      if (usuario.cargo === "" || usuario.cargo === undefined) {
        dispatch(userActions.setFieldValid({ id: "cargo", value: false }));
        value = false;
      }
      if (usuario.departamento === "" || usuario.departamento === undefined) {
        dispatch(
          userActions.setFieldValid({ id: "departamento", value: false })
        );
        value = false;
      }
      break;
    default:
      value = true;
  }
  return value;
};
export const validateAllFields = (usuario, dispatch) => {
  let value = true;
  if (
    usuario.email === "" ||
    usuario.email === undefined ||
    !isValidEmail(usuario.email)
  ) {
    dispatch(userActions.setFieldValid({ id: "email", value: false }));
    value = false;
  } else {
    dispatch(userActions.setFieldValid({ id: "email", value: true }));
  }
  if (usuario.nombres === "" || usuario.nombres === undefined) {
    dispatch(userActions.setFieldValid({ id: "nombres", value: false }));
    value = false;
  } else {
    dispatch(userActions.setFieldValid({ id: "nombres", value: true }));
  }
  if (usuario.apellidos === "" || usuario.apellidos === undefined) {
    dispatch(userActions.setFieldValid({ id: "apellidos", value: false }));
    value = false;
  } else {
    dispatch(userActions.setFieldValid({ id: "apellidos", value: true }));
  }
  if (usuario.identificacion === "" || usuario.identificacion === undefined) {
    dispatch(
      userActions.setFieldValid({ id: "identificacion", value: false })
    );
    value = false;
  } else {
    dispatch(userActions.setFieldValid({ id: "apellidos", value: true }));
  }
  if (usuario.telefonoCelular === "" || usuario.telefonoCelular === undefined) {
    dispatch(
      userActions.setFieldValid({ id: "telefonoCelular", value: false })
    );
    value = false;
  } else {
    dispatch(userActions.setFieldValid({ id: "telefonoCelular", value: true }));
  }
  if (usuario.pais === "" || usuario.pais === undefined) {
    dispatch(userActions.setFieldValid({ id: "pais", value: false }));
    value = false;
  } else {
    dispatch(userActions.setFieldValid({ id: "pais", value: true }));
  }
  if (usuario.ciudad === "" || usuario.ciudad === undefined) {
    dispatch(userActions.setFieldValid({ id: "ciudad", value: false }));
    value = false;
  } else {
    dispatch(userActions.setFieldValid({ id: "ciudad", value: true }));
  }
  if (usuario.direccion === "" || usuario.direccion === undefined) {
    dispatch(userActions.setFieldValid({ id: "direccion", value: false }));
    value = false;
  } else {
    dispatch(userActions.setFieldValid({ id: "direccion", value: true }));
  }
  if (usuario.entidadLabora === "" || usuario.entidadLabora === undefined) {
    dispatch(
      userActions.setFieldValid({ id: "entidadLabora", value: false })
    );
    value = false;
  } else {
    dispatch(userActions.setFieldValid({ id: "entidadLabora", value: true }));
  }
  if (usuario.cargo === "" || usuario.cargo === undefined) {
    dispatch(userActions.setFieldValid({ id: "cargo", value: false }));
    value = false;
  } else {
    dispatch(userActions.setFieldValid({ id: "cargo", value: true }));
  }
  if (usuario.departamento === "" || usuario.departamento === undefined) {
    dispatch(
      userActions.setFieldValid({ id: "departamento", value: false })
    );
    value = false;
  } else {
    dispatch(userActions.setFieldValid({ id: "departamento", value: true }));
  }
  return value;
};
